import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const McdInvList = () => {

  const augFieldDefs = (fieldToFieldDef) => {

    // 0. Invoice Number
    fieldToFieldDef.invNum.precedence = -1;

    // 1. Dimensions
    fieldToFieldDef.stateId.precedence = 0;
    fieldToFieldDef.stateId.hasName = false;

    fieldToFieldDef.ctrtId.precedence = 1;
    fieldToFieldDef.ctrtId.hasName = false;

    fieldToFieldDef.labelerId.precedence = 2;
    fieldToFieldDef.labelerId.hasName = false;

    fieldToFieldDef.invPeriodId.precedence = 3;
    fieldToFieldDef.invPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;
    fieldToFieldDef.sumStatus.precedence = 1002;
    fieldToFieldDef.cldStatus.precedence = 1003;

    // // 3. Units
    // fieldToFieldDef.invUnits.precedence = 2000;
    // fieldToFieldDef.dispUnits.precedence = 2001;
    // fieldToFieldDef.dueUnits.precedence = 2002;
    // fieldToFieldDef.paidUnits.precedence = 2003;

    // // 4. URAs
    // fieldToFieldDef.invUra.precedence = 3000;
    // fieldToFieldDef.calcUra.precedence = 3001;

    // 5. Amounts
    fieldToFieldDef.extInvAmt.precedence = 4000;
    fieldToFieldDef.incrInvAmt.precedence = 4001;
    fieldToFieldDef.incrDispAmt.precedence = 4002;
    fieldToFieldDef.incrDueAmt.precedence = 4003;
    fieldToFieldDef.incrPaidAmt.precedence = 4004;

    // 6. Other
    fieldToFieldDef.mcdInvOrigin.precedence = 9000;
    fieldToFieldDef.postmarkDate.precedence = 9001;
    fieldToFieldDef.dueDate.precedence = 9002;
    fieldToFieldDef.pymtDate.precedence = 9003;
    fieldToFieldDef.lineCount.precedence = 9004;
    fieldToFieldDef.valLineCount.precedence = 9005;
    fieldToFieldDef.mcdStateId.precedence = 9006;
    fieldToFieldDef.mcdInvDateTrackerId.precedence = 9007;
    fieldToFieldDef.payWithoutCld.precedence = 9008;
  }
  
  return (
    <EntityList entity="MCD_INV" augFieldDefs={augFieldDefs}/>
  )
}